<div main>
  <div players>
    @for (player of ts.playerList; track $index) {
      <div [style]="styleForPlayer(player)" player>
        <div name>
          @if (player.playerIdx === editPlayerIdx) {
            <mat-form-field>
              <mat-label>Player Name</mat-label>
              <input (blur)="savePlayer(player)" [(ngModel)]="player.name" matInput playerName>
            </mat-form-field>
          } @else {
            <button (click)="clickPlayerName(player)" mat-button>
              {{ player.name }}
            </button>
          }
          @if (ts.boardMode() === BoardMode.Play && globals.isDebug && $index === 0 && player.cards.length > 2) {
            <button (click)="clickCycle($event, player)" mat-icon-button>
              <mat-icon>360</mat-icon>
            </button>
            <button (click)="clickShuffle($event, player)" mat-icon-button>
              <mat-icon>shuffle</mat-icon>
            </button>
          }
          @if (ts.boardMode() === BoardMode.Prepare && ts.players.length > 2) {
            <button (click)="clickDeletePlayer($event, player)" mat-icon-button>
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
        @if (ts.cardList(player).length > 0) {
          <div hand>
            @switch (ts.boardMode()) {
              @case (BoardMode.Prepare) {
                @switch (ts.gameMode()) {
                  @case (GameMode.Normal) {
                    <app-tacta-card [canvas]="ts.cardOfPlayer(player,0,0)"></app-tacta-card>
                  }
                  @case (GameMode.Sabotage) {
                    <app-tacta-card [canvas]="ts.suiteOfPlayer(player,0)"></app-tacta-card>
                    <app-tacta-card [canvas]="ts.suiteOfPlayer(player,1)"></app-tacta-card>
                    <app-tacta-card [canvas]="ts.suiteOfPlayer(player,2)"></app-tacta-card>
                  }
                  @case (GameMode.Quick) {
                    <app-tacta-card [canvas]="ts.suiteOfPlayer(player,0)"></app-tacta-card>
                    <app-tacta-card [canvas]="ts.suiteOfPlayer(player,1)"></app-tacta-card>
                    <app-tacta-card [canvas]="ts.suiteOfPlayer(player,2)"></app-tacta-card>
                  }
                }
              }
              @case (BoardMode.Play) {
                @if (ts.playerMode() === PlayerMode.SelectCard || $index > 0) {
                  <app-tacta-card [canvas]="ts.cardOfPlayer(player,0,0)"></app-tacta-card>
                  @if (ts.cardList(player)?.length > 1) {
                    <app-tacta-card [canvas]="ts.cardOfPlayer(player, 999, ts.cardList(player)?.length - 1)"></app-tacta-card>
                  }
                } @else if (ts.playerMode() === PlayerMode.PlaceCard && $index === 0) {
                  <div handControls>
                    <button (click)="clickConfirm($event)" [disabled]="!ts.mayConfirm()" mat-mini-fab ok>
                      <mat-icon>done</mat-icon>
                    </button>
                    <button (click)="clickCancel($event)" cancel mat-mini-fab>
                      <mat-icon>undo</mat-icon>
                    </button>
                  </div>
                }
              }
            }
            @if (ts.boardMode() === BoardMode.Prepare) {
              <div colors>
                @for (color of colorList(player); track $index) {
                  <button (click)="clickColor($event, player, color)" [style]="styleForColor(player, color)" mat-button>
                    <mat-icon>palette</mat-icon>
                  </button>
                }
              </div>
            }
          </div>
          @if (ts.gameMode() === GameMode.Quick && ts.boardMode() === BoardMode.Prepare) {
            <div quick-score>
              <div [attr.data-text]="scoreQuick(player)" [class]="classForScoreQuick(player)">
                {{ scoreQuick(player) }}
              </div>
            </div>
          }
        }
        @if (false && ts.boardMode() === BoardMode.Prepare) {
          <div fullhand>
            @for (_card of ts.cardList(player); track $index) {
              <app-tacta-card [canvas]="ts.cardOfPlayer(player,$index+1000,$index,1)"></app-tacta-card>
            }
          </div>
        }
        <div [attr.data-text]="score(player)" [class]="classForScore(player)" score>
          {{ score(player) }}
        </div>
        <svg style="height: 0; width: 0; position: absolute;">
          <filter id="distress">
            <feTurbulence baseFrequency="0.05" numOctaves="2" result="noise" type="fractalNoise"/>
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="5"/>
          </filter>
        </svg>
        @if ($index > 0 && ts.boardMode() === BoardMode.Play) {
          <div disable></div>
        }
      </div>
    }
  </div>
  @if (ts.boardMode() === BoardMode.Play) {
    <div board>
      <div [class]="classForBoard" inner>
        @for (cvs of ts.board; track $index) {
          @if (ts.board.length > 1) {
            <app-tacta-card [canvas]="cvs" info="{{Utils.hex($index)}}"></app-tacta-card>
          } @else {
            <app-tacta-board [canvas]="cvs"></app-tacta-board>
          }
        }
      </div>
    </div>
  }
</div>
@if (ts.boardMode() === BoardMode.Prepare) {
  <div controls>
    @if (globals.isDebug) {
      <button [cdkCopyToClipboard]="ts.board[0]?.asString()" class="debug" info mat-mini-fab>
        <mat-icon>content_copy</mat-icon>
      </button>
      <button (click)="clickSave($event)" class="debug" mat-mini-fab>
        <mat-icon>save</mat-icon>
      </button>
      @if (ts.boardMode() === BoardMode.Prepare && tcs.hasSaved) {
        <button (click)="clickLoad($event)" class="debug" mat-mini-fab>
          @if (tcs.useSaved) {
            <mat-icon>download</mat-icon>
          } @else {
            <img height="24px" src="assets/images/site-tacta.png">
          }
        </button>
      }
      @if (ts.boardMode() === BoardMode.Play) {
        <button (click)="clickErrorCheck($event)" class="debug" mat-mini-fab>
          <mat-icon>error</mat-icon>
        </button>
      }
    }
    @if (ts.players.length < ts.colors.length - 1) {
      <button (click)="clickAddPlayer($event)" mat-mini-fab>
        <mat-icon>add</mat-icon>
      </button>
    }
    <a href="https://boardgamearena.com/gamepanel?game=tacta" mat-mini-fab target="_blank">
      <mat-icon>open_in_new</mat-icon>
    </a>
  </div>
}
